export default __webpack_public_path__ + "static/media/nuestroSocio.3f1163c7.png";